/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import './app/shared/primeng-drawer-mask-fix';


bootstrapApplication(AppComponent, appConfig)
  .catch((err: unknown) => { console.error(err); });